import {
  Component,
  inject,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { WishListNavComponent } from './wish-list-nav/wish-list-nav.component';
import { CartNavComponent } from './cart-nav/cart-nav.component';
import { OKTA_AUTH } from '@okta/okta-angular';
import { NgClass } from '@angular/common';
import { SvgIconComponent } from '@utilities/components/svg-icon/svg-icon.component';
import { filter } from 'rxjs/operators';
import { ModalService } from '../../../shared/services/modal.service';
import { AuthService } from '../../../auth/services/auth.service';
import { HolidayTypes } from '../../../shared/enums/holiday-types.enum';
import { HolidayDataService } from '../../services/holiday-data.service';
import { ShowFeatureDirective } from '../../../shared/directives/show-feature.directive';
import { Feature } from '../../../shared/enums/feature.enum';
import { NotificationsNavComponent } from './notifications-nav/notifications-nav.component';

declare const bootstrap: any;

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    WishListNavComponent,
    CartNavComponent,
    NgClass,
    SvgIconComponent,
    ShowFeatureDirective,
    NotificationsNavComponent,
  ],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  private authService = inject(AuthService);
  private oktaAuth = inject(OKTA_AUTH);
  private router = inject(Router);
  private modalService = inject(ModalService);
  private menuElement: HTMLElement | null = null;
  holidayDataService = inject(HolidayDataService);
  HolidayTypes = HolidayTypes;
  Feature = Feature;

  principalMenuItems = this.router.config
    .filter((route) => !!route.data && route.data['isPrincipalMenu'])
    .map((route) => ({
      path: route.path ?? '',
      class: route.data ? route.data['class'] ?? '' : '',
      image: route.data ? route.data['image'] ?? '' : '',
    }));

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.closeMenu();
      });
  }

  ngAfterViewInit() {
    this.menuElement = document.getElementById('circleMnu');
    if (this.menuElement) {
      this.menuElement.addEventListener('show.bs.collapse', this.onShowMenu);
      this.menuElement.addEventListener('hidden.bs.collapse', this.onHideMenu);
    }
  }

  ngOnDestroy() {
    if (this.menuElement) {
      this.menuElement.removeEventListener('show.bs.collapse', this.onShowMenu);
      this.menuElement.removeEventListener(
        'hidden.bs.collapse',
        this.onHideMenu
      );
    }
  }

  onShowMenu = () => {
    document.body.classList.add('no-scroll');
  };

  onHideMenu = () => {
    document.body.classList.remove('no-scroll');
  };

  closeMenu() {
    const menu = document.getElementById('circleMnu');
    if (menu && typeof bootstrap !== 'undefined') {
      const bsCollapse = bootstrap.Collapse.getInstance(menu);
      if (bsCollapse) {
        bsCollapse.hide();
      }
    }
  }

  openModalMyProgress() {
    this.modalService.openMyProgressModal();
  }

  async logOut() {
    if (this.oktaAuth.getAccessToken()) {
      await this.oktaAuth.signOut();
    }
    if (this.authService.isLoggedIn()) {
      this.authService.logout();
    }
    this.router.navigate(['']);

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
}
